import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue";
import _imports_0 from '@/assets/Mantaraya.png';
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = { class: "flex items-center gap-3" };
const _hoisted_4 = ["alt"];
const _hoisted_5 = { class: "flex-1 px-3 py-4 space-y-1 overflow-y-auto" };
const _hoisted_6 = { class: "flex items-center gap-3" };
const _hoisted_7 = { class: "flex items-center gap-3" };
const _hoisted_8 = { class: "flex items-center gap-3" };
const _hoisted_9 = { class: "flex items-center gap-3" };
const _hoisted_10 = { class: "flex items-center gap-3" };
const _hoisted_11 = { class: "flex items-center gap-3" };
const _hoisted_12 = { class: "flex items-center gap-3" };
const _hoisted_13 = { class: "flex items-center gap-3" };
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
    key: 0,
    class: "absolute w-2 h-2 border border-white rounded-full top-1 right-1 bg-eorange-500"
};
const _hoisted_16 = {
    key: 0,
    class: "ml-2 rounded-full bg-eorange-500 px-2 py-0.5 text-xs font-semibold text-white",
    "data-test": "message-unread-badge"
};
const _hoisted_17 = {
    key: 1,
    class: "ml-2 rounded-full bg-eorange-500 px-2 py-0.5 text-xs font-semibold text-white",
    "data-test": "notification-unread-badge"
};
const _hoisted_18 = { class: "flex items-center gap-3" };
const _hoisted_19 = { class: "p-2 transition-colors duration-200 rounded-lg bg-gray-100/50 group-hover:bg-gray-100" };
const _hoisted_20 = { class: "flex items-center gap-3" };
const _hoisted_21 = { class: "flex items-center gap-3" };
const _hoisted_22 = { class: "w-6 h-6" };
const _hoisted_23 = { class: "relative flex flex-col gap-3 px-3 py-2.5 rounded-xl mt-2" };
const _hoisted_24 = { class: "flex items-center gap-3" };
const _hoisted_25 = { class: "flex text-sm" };
const _hoisted_26 = { class: "sr-only" };
const _hoisted_27 = { class: "flex items-center justify-center rounded-full bg-eorange-400" };
const _hoisted_28 = {
    class: "w-10 h-10 text-white",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
};
const _hoisted_29 = {
    x: "50%",
    y: "55%",
    "dominant-baseline": "middle",
    "text-anchor": "middle",
    "font-size": "50",
    fill: "currentColor",
    "font-family": "Arial, sans-serif"
};
const _hoisted_30 = { class: "min-w-0" };
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { IconArrowBackUp, IconBuildingCommunity, IconCreditCard, IconCurrencyDollar, IconLogout2, IconMenu, IconSettings, IconStar, IconTags, IconUsers, IconX } from "@tabler/icons-vue";
import posthog from "posthog-js";
import { useToast } from "vue-toastification";
import { getUserData } from "@/plugins/shared";
import { useAbility, useAuthStore } from "@/domains/auth";
import { useConversationStore } from "@/domains/conversation";
import { useNotificationStore } from "@/domains/notification/stores";
import { notificationSoundService } from "@/domains/notification/services/notification-sound.service";
import { OrgSwitcher, useOrganizationContextSwitch } from "@/domains/organization";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { FEATURE_FLAGS } from "@/constants/feature-flags";
const serviceIcon = '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-box-multiple"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z" /><path d="M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2" /></svg>';
const notificationIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg>';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardNavigation',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const { t } = useI18n();
        const toast = useToast();
        const { can } = useAbility();
        const authStore = useAuthStore();
        const conversationStore = useConversationStore();
        const notificationStore = useNotificationStore();
        const contextSwitch = useOrganizationContextSwitch();
        const featureFlagStore = useFeatureFlagStore();
        const messageUnreadBadge = computed(() => {
            if (isGlobalAdminMode.value || conversationStore.unreadMessageNotificationCount <= 0) {
                return "";
            }
            return conversationStore.unreadMessageNotificationCount > 99
                ? "99+"
                : String(conversationStore.unreadMessageNotificationCount);
        });
        const messageUnreadIndicator = computed(() => {
            if (isGlobalAdminMode.value)
                return "";
            if (messageUnreadBadge.value)
                return "";
            return conversationStore.hasNewMessages ? "dot" : "";
        });
        const notificationUnreadBadge = computed(() => {
            if (isGlobalAdminMode.value || notificationStore.unreadCount <= 0)
                return "";
            return notificationStore.unreadCount > 99
                ? "99+"
                : String(notificationStore.unreadCount);
        });
        const isGlobalAdminMode = computed(() => route.meta.globalAdmin === true || route.path.startsWith("/admin/global"));
        const settingsRoute = computed(() => authStore.isSuperAdmin && authStore.currentOrgId
            ? "/admin/settings/users"
            : "/admin/settings");
        const isMobileMenuOpen = ref(false);
        const userNameLetter = ref("");
        const userInfo = ref({ name: "", email: "" });
        const soundGestureEvents = ["pointerdown", "click", "keydown"];
        let soundGestureListenersInstalled = false;
        const allLinks = [
            {
                labelKey: "shell.navigation.links.dashboard",
                link: "/admin",
                icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-layout-dashboard"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" /><path d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" /><path d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" /><path d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.providers",
                link: "/admin/catalog/providers",
                abilityCheck: { action: "read", subject: "ProviderCatalog" },
                allowedOrgTypes: ["concierge"],
                icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-users-group"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" /><path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M17 10h2a2 2 0 0 1 2 2v1" /><path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M3 13v-1a2 2 0 0 1 2 -2h2" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.calendar",
                link: "/admin/calendar",
                abilityCheck: { action: "read", subject: "Calendar" },
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class=""><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M4 11h16" /><path d="M11 15h1" /><path d="M12 15v3" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.customers",
                link: "/admin/customer",
                abilityCheck: { action: "read", subject: "Customer" },
                icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-users"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" /><path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /><path d="M21 21v-2a4 4 0 0 0 -3 -3.85" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.itinerary",
                link: "/admin/itinerary",
                abilityCheck: { action: "read", subject: "Itinerary" },
                icon: '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-calendar-month"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M4 11h16" /><path d="M7 14h.013" /><path d="M10.01 14h.005" /><path d="M13.01 14h.005" /><path d="M16.015 14h.005" /><path d="M13.015 17h.005" /><path d="M7.01 17h.005" /><path d="M10.01 17h.005" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.reservations",
                link: "/admin/reservas",
                abilityCheck: { action: "read", subject: "Reservation" },
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-calendar-check"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M4 11h16" /><path d="M15 19l2 2l4 -4" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.messages",
                link: "/admin/conversations",
                abilityCheck: { action: "read", subject: "Conversation" },
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 9h8" /><path d="M8 13h6" /><path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.notifications",
                link: "/admin/notifications",
                abilityCheck: { action: "read", subject: "Notification" },
                featureFlag: FEATURE_FLAGS.NOTIFICATIONS,
                icon: notificationIcon,
            },
            {
                labelKey: "shell.navigation.links.payments",
                labelKeyByOrgType: {
                    concierge: "shell.navigation.links.collections",
                },
                link: "/admin/payments",
                abilityCheck: { action: "read", subject: "PaymentOperations" },
                allowedOrgTypes: ["provider", "concierge"],
                featureFlag: FEATURE_FLAGS.ITINERARY_ONVO_PAYMENTS,
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z" /><path d="M3 10l18 0" /><path d="M7 15l.01 0" /><path d="M11 15l2 0" /></svg>',
            },
            {
                labelKey: "shell.navigation.links.reviews",
                link: "/admin/reviews",
                abilityCheck: { action: "read", subject: "Review" },
                allowedOrgTypes: ["provider", "concierge"],
                featureFlag: FEATURE_FLAGS.REVIEWS,
                icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" /></svg>',
            },
        ];
        const visibleLinks = computed(() => allLinksWithServiceLink.value.filter((link) => {
            if (link.allowedOrgTypes &&
                !authStore.isSuperAdmin &&
                (!authStore.currentOrgType ||
                    !link.allowedOrgTypes.includes(authStore.currentOrgType))) {
                return false;
            }
            if (link.featureFlag && !featureFlagStore.isRuntimeEnabled(link.featureFlag)) {
                return false;
            }
            if (!link.abilityCheck)
                return true;
            return can(link.abilityCheck.action, link.abilityCheck.subject);
        }));
        const serviceNavLink = computed(() => {
            if (authStore.currentOrgType === "concierge" && can("read", "Service")) {
                return {
                    labelKey: "shell.navigation.links.services",
                    link: "/admin/catalog/services",
                    abilityCheck: { action: "read", subject: "Service" },
                    allowedOrgTypes: ["concierge"],
                    icon: serviceIcon,
                };
            }
            if (can("read", "Service")) {
                return {
                    labelKey: "shell.navigation.links.services",
                    link: "/admin/service",
                    abilityCheck: { action: "read", subject: "Service" },
                    allowedOrgTypes: ["provider"],
                    icon: serviceIcon,
                };
            }
            return null;
        });
        const allLinksWithServiceLink = computed(() => {
            const serviceLink = serviceNavLink.value;
            if (!serviceLink)
                return allLinks;
            const insertAfterProviderCatalog = allLinks.findIndex((link) => link.link === "/admin/catalog/providers");
            const privateLinks = authStore.currentOrgType === "concierge" ? [
                { labelKey: "shell.navigation.links.private_providers", link: "/admin/provider", abilityCheck: { action: "manage", subject: "Provider" }, allowedOrgTypes: ["concierge"], icon: allLinks.find(link => link.link === "/admin/catalog/providers").icon },
                { labelKey: "shell.navigation.links.private_services", link: "/admin/service", abilityCheck: { action: "manage", subject: "Service" }, allowedOrgTypes: ["concierge"], icon: serviceIcon },
            ] : [];
            return [
                ...allLinks.slice(0, insertAfterProviderCatalog + 1),
                serviceLink,
                ...privateLinks,
                ...allLinks.slice(insertAfterProviderCatalog + 1),
            ];
        });
        function navigationLabelKey(link) {
            const orgType = authStore.currentOrgType;
            if (!orgType)
                return link.labelKey;
            return link.labelKeyByOrgType?.[orgType] ?? link.labelKey;
        }
        async function handleLogout() {
            posthog.reset();
            await authStore.logout();
            router.push("/login");
            toast.success(t("shell.navigation.logout_success"), {
                timeout: 3000,
                position: "top-right",
            });
        }
        function handleReturnToGlobalConsole() {
            contextSwitch.enterGlobalConsole();
            isMobileMenuOpen.value = false;
            router.push("/admin/global/organizations");
        }
        function setUser() {
            userInfo.value = getUserData();
            userNameLetter.value = userInfo.value.name?.charAt(0) ?? "";
        }
        onMounted(() => {
            setUser();
            installSoundGestureListeners();
            void refreshTenantRealtimeState();
        });
        onUnmounted(() => {
            removeSoundGestureListeners();
            conversationStore.disconnectSSE();
        });
        watch(() => [authStore.currentOrgId, isGlobalAdminMode.value], () => void refreshTenantRealtimeState());
        async function refreshTenantRealtimeState() {
            if (authStore.isSuperAdmin) {
                await featureFlagStore.loadGlobal();
            }
            if (!authStore.currentOrgId || isGlobalAdminMode.value) {
                conversationStore.disconnectSSE();
                return;
            }
            await featureFlagStore.loadRuntime(authStore.currentOrgId);
            conversationStore.connectSSE();
            if (featureFlagStore.isRuntimeEnabled(FEATURE_FLAGS.NOTIFICATIONS)) {
                notificationStore.fetchUnreadCount();
            }
            conversationStore.fetchUnreadMessageNotificationCount();
        }
        function installSoundGestureListeners() {
            if (soundGestureListenersInstalled)
                return;
            soundGestureListenersInstalled = true;
            soundGestureEvents.forEach((eventName) => {
                window.addEventListener(eventName, enableNotificationSounds, {
                    once: true,
                    passive: true,
                    capture: true,
                });
            });
        }
        function removeSoundGestureListeners() {
            if (!soundGestureListenersInstalled)
                return;
            soundGestureListenersInstalled = false;
            soundGestureEvents.forEach((eventName) => {
                window.removeEventListener(eventName, enableNotificationSounds, {
                    capture: true,
                });
            });
        }
        function enableNotificationSounds() {
            notificationSoundService.enableAfterUserGesture();
            removeSoundGestureListeners();
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (isMobileMenuOpen.value = true)),
                    class: _normalizeClass(["fixed top-4 left-4 z-40 xl:hidden p-2.5 rounded-xl backdrop-blur-sm border shadow-lg transition-colors",
                        isGlobalAdminMode.value
                            ? 'bg-eblack-900/95 border-eblack-700 hover:bg-eblack-800'
                            : 'bg-white/90 border-gray-200 hover:bg-gray-50'
                    ]),
                    "aria-label": _unref(t)('shell.navigation.open_menu')
                }, [
                    _createVNode(_unref(IconMenu), {
                        class: _normalizeClass(["w-5 h-5", isGlobalAdminMode.value ? 'text-white' : 'text-gray-700'])
                    }, null, 8, ["class"])
                ], 10, _hoisted_1),
                (isMobileMenuOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fixed inset-0 z-40 duration-200 bg-black/30 backdrop-blur-sm lg:hidden animate-in fade-in",
                        onClick: _cache[1] || (_cache[1] = ($event) => (isMobileMenuOpen.value = false))
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("aside", {
                    class: _normalizeClass(["fixed inset-y-0 left-0 z-50 flex flex-col w-64 h-screen transition-transform duration-300 ease-in-out border-r lg:static md:w-80 lg:w-64 backdrop-blur-xl", [
                            isMobileMenuOpen.value
                                ? 'translate-x-0'
                                : '-translate-x-full lg:translate-x-0',
                            isGlobalAdminMode.value
                                ? 'bg-eblack-950 border-eblack-800 text-ewhite-50'
                                : 'bg-white/80 border-gray-200/60',
                        ]])
                }, [
                    _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event) => (isMobileMenuOpen.value = false)),
                        class: _normalizeClass(["absolute p-2 transition-colors rounded-lg top-4 right-4 lg:hidden", isGlobalAdminMode.value ? 'hover:bg-eblack-800' : 'hover:bg-gray-100']),
                        "aria-label": _unref(t)('shell.navigation.close_menu')
                    }, [
                        _createVNode(_unref(IconX), {
                            class: _normalizeClass(["w-5 h-5", isGlobalAdminMode.value ? 'text-ewhite-100' : 'text-gray-600'])
                        }, null, 8, ["class"])
                    ], 10, _hoisted_2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["px-5 py-4 border-b", isGlobalAdminMode.value ? 'border-eblack-800' : 'border-gray-200/60'])
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center justify-center shadow-lg w-9 h-9 rounded-xl", isGlobalAdminMode.value ? 'bg-ewhite-50' : 'bg-gradient-to-br from-ewhite-50 to-eblack-300'])
                            }, [
                                _createElementVNode("img", {
                                    src: _imports_0,
                                    alt: _unref(t)('shell.navigation.logo_alt'),
                                    class: "w-8 h-8"
                                }, null, 8, _hoisted_4)
                            ], 2),
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", {
                                    class: _normalizeClass(["text-lg font-bold tracking-tight", isGlobalAdminMode.value ? 'text-white' : 'text-gray-900'])
                                }, _toDisplayString(_ctx.$t("dashboard.auto.emanta")), 3),
                                _createElementVNode("p", {
                                    class: _normalizeClass(["text-xs", isGlobalAdminMode.value ? 'text-ewhite-300' : 'text-gray-500'])
                                }, _toDisplayString(isGlobalAdminMode.value ? _unref(t)("shell.navigation.global_console") : _unref(t)("shell.navigation.control_panel")), 3)
                            ])
                        ])
                    ], 2),
                    _createElementVNode("nav", _hoisted_5, [
                        (isGlobalAdminMode.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/organizations',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/organizations')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[3] || (_cache[3] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/organizations')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconBuildingCommunity), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_organizations")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/admins',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/admins')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/admins')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconUsers), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_admins")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/categories',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/categories')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/categories')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconTags), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_service_categories")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/configuration',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/configuration')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/configuration')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconSettings), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_configuration")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/reviews',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/reviews')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[7] || (_cache[7] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/reviews')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconStar), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_reviews")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: '/admin/global/charges',
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path.includes('/admin/global/charges')
                                            ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                            : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    ]),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path.includes('/admin/global/charges')
                                                        ? 'bg-white text-eblack-700'
                                                        : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconCurrencyDollar), { class: "w-6 h-6" })
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_charges")), 1)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["class"]),
                                (_unref(featureFlagStore).isGlobalEnabled(_unref(FEATURE_FLAGS).ORGANIZATION_BILLING))
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        to: '/admin/global/billing',
                                        class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                            _ctx.$route.path.includes('/admin/global/billing')
                                                ? 'bg-ewhite-50 text-eblack-900 shadow-sm'
                                                : 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                        ]),
                                        onClick: _cache[9] || (_cache[9] = ($event) => (isMobileMenuOpen.value = false))
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_12, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                        _ctx.$route.path.includes('/admin/global/billing')
                                                            ? 'bg-white text-eblack-700'
                                                            : 'bg-eblack-900 text-ewhite-200 group-hover:bg-eblack-700 group-hover:text-white'
                                                    ])
                                                }, [
                                                    _createVNode(_unref(IconCreditCard), { class: "w-6 h-6" })
                                                ], 2),
                                                _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.links.global_billing")), 1)
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["class"]))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(visibleLinks.value, (link) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                    key: link.labelKey,
                                    to: link.link,
                                    class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                        _ctx.$route.path === link.link
                                            ? 'bg-gradient-to-r from-eorange-200 to-eorange-400 text-ewhite-50 shadow-sm'
                                            : 'text-eblack-600 hover:bg-ewhite-100 hover:text-eblack-900'
                                    ]),
                                    onClick: _cache[10] || (_cache[10] = ($event) => (isMobileMenuOpen.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["relative p-2 transition-colors duration-200 rounded-lg",
                                                    _ctx.$route.path === link.link
                                                        ? 'bg-white shadow-sm'
                                                        : 'bg-gray-100/50 group-hover:bg-gray-100'
                                                ])
                                            }, [
                                                _createElementVNode("span", {
                                                    innerHTML: link.icon,
                                                    class: _normalizeClass(["w-6 h-6",
                                                        _ctx.$route.path === link.link
                                                            ? 'text-eblack-600'
                                                            : 'text-eblack-500 group-hover:text-eblack-700'
                                                    ])
                                                }, null, 10, _hoisted_14),
                                                (link.link === '/admin/conversations' && messageUnreadIndicator.value === 'dot')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                                                    : _createCommentVNode("", true)
                                            ], 2),
                                            _createElementVNode("span", null, _toDisplayString(_unref(t)(navigationLabelKey(link))), 1)
                                        ]),
                                        (link.link === '/admin/conversations' && messageUnreadBadge.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(messageUnreadBadge.value), 1))
                                            : (link.link === '/admin/notifications' && notificationUnreadBadge.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(notificationUnreadBadge.value), 1))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["to", "class"]));
                            }), 128))
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["z-50 px-3 py-4 space-y-1 border-t", isGlobalAdminMode.value ? 'border-eblack-800' : 'border-gray-200/60'])
                    }, [
                        (_unref(authStore).isSuperAdmin && _unref(authStore).currentOrgId && !isGlobalAdminMode.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "group flex w-full items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium text-eblack-600 transition-all duration-200 ease-in-out hover:bg-ewhite-100 hover:text-eblack-900",
                                onClick: handleReturnToGlobalConsole
                            }, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_unref(IconArrowBackUp), { class: "w-6 h-6" })
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.return_global_console")), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!isGlobalAdminMode.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: settingsRoute.value,
                                class: _normalizeClass(["group flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                    _ctx.$route.path.includes('/admin/settings')
                                        ? 'bg-gradient-to-r from-eorange-200 to-eorange-400 text-ewhite-50 shadow-sm'
                                        : 'text-eblack-600 hover:bg-ewhite-100 hover:text-eblack-900'
                                ]),
                                onClick: _cache[11] || (_cache[11] = ($event) => (isMobileMenuOpen.value = false))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                                _ctx.$route.path === '/admin/settings'
                                                    ? 'bg-white shadow-sm'
                                                    : 'bg-gray-100/50 group-hover:bg-gray-100'
                                            ])
                                        }, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["w-6 h-6",
                                                    _ctx.$route.path.includes('/admin/settings')
                                                        ? 'text-eblack-600'
                                                        : 'text-eblack-500 group-hover:text-eblack-700'
                                                ])
                                            }, [
                                                _createVNode(_unref(IconSettings))
                                            ], 2)
                                        ], 2),
                                        _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.settings")), 1)
                                    ])
                                ]),
                                _: 1
                            }, 8, ["to", "class"]))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["group w-full flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ease-in-out",
                                isGlobalAdminMode.value
                                    ? 'text-ewhite-200 hover:bg-eblack-800 hover:text-white'
                                    : 'text-eblack-600 hover:bg-ewhite-100 hover:text-eblack-900'
                            ]),
                            onClick: handleLogout
                        }, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["p-2 transition-colors duration-200 rounded-lg",
                                        isGlobalAdminMode.value
                                            ? 'bg-eblack-900 group-hover:bg-eblack-700'
                                            : 'bg-gray-100/50 group-hover:bg-gray-100'
                                    ])
                                }, [
                                    _createElementVNode("span", _hoisted_22, [
                                        _createVNode(_unref(IconLogout2))
                                    ])
                                ], 2),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)("shell.navigation.logout")), 1)
                            ])
                        ], 2),
                        _createElementVNode("div", _hoisted_23, [
                            (!isGlobalAdminMode.value && (_unref(authStore).currentOrgId || _unref(authStore).activeMemberships.length > 0))
                                ? (_openBlock(), _createBlock(_unref(OrgSwitcher), { key: 0 }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)("shell.navigation.open_user_menu")), 1),
                                    _createElementVNode("div", _hoisted_27, [
                                        (_openBlock(), _createElementBlock("svg", _hoisted_28, [
                                            _createElementVNode("text", _hoisted_29, _toDisplayString(userNameLetter.value), 1)
                                        ]))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("p", {
                                        class: _normalizeClass(["truncate text-sm font-medium", isGlobalAdminMode.value ? 'text-white' : 'text-gray-900'])
                                    }, _toDisplayString(userInfo.value.name), 3),
                                    _createElementVNode("p", {
                                        class: _normalizeClass(["truncate text-xs", isGlobalAdminMode.value ? 'text-ewhite-300' : 'text-gray-500'])
                                    }, _toDisplayString(userInfo.value.email), 3)
                                ])
                            ])
                        ])
                    ], 2)
                ], 2)
            ]));
        };
    }
});
